import _regeneratorRuntime from "D:/project/e-his\u968F\u8BBF\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/project/e-his\u968F\u8BBF\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.json.stringify.js";
import { getToken, setToken, removeToken as _removeToken, setUserInfo, getUserInfo, removeUserInfo as _removeUserInfo } from '@/utils/auth';
import { login as _login, getUserDetail } from '@/api/login';
// import { Promise } from 'core-js'
import { resetRouter } from '@/router';
import { invokeApi } from "@/utils/shared";
var getDefaultState = function getDefaultState() {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    staffCode: null,
    userInfo: JSON.parse(getUserInfo()) || {}
  };
};
var state = getDefaultState();
var mutations = {
  changgeToken: function changgeToken(state, token) {
    state.token = token;
  },
  changeUserInfo: function changeUserInfo(state, data) {
    state.userInfo = data;
  },
  //删除userInfo
  removeUserInfo: function removeUserInfo(state) {
    state.userInfo = {};
    _removeUserInfo();
  },
  //删除token
  removeToken: function removeToken() {
    //删除vuex的token
    state.token = null;
    //清除本地的token
    _removeToken();
  },
  setStaffCode: function setStaffCode(state, data) {
    state.staffCode = data;
  },
  removeStaffCode: function removeStaffCode(state) {
    state.staffCode = null;
  }
};
var actions = {
  login: function login(_ref, from) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var commit, dispatch, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit, dispatch = _ref.dispatch;
            _context.next = 3;
            return _login(from);
          case 3:
            res = _context.sent;
            if (!(res.code == 20000)) {
              _context.next = 10;
              break;
            }
            commit('changgeToken', res.data.token);
            setToken(res.data.token);
            return _context.abrupt("return", 'ok');
          case 10:
            return _context.abrupt("return", Promise.reject(new Error(res.msg)));
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  getUserInfo: function getUserInfo(_ref2) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var commit, res;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref2.commit;
            _context2.next = 3;
            return invokeApi(getUserDetail);
          case 3:
            res = _context2.sent;
            commit('changeUserInfo', res.data);
            commit('setStaffCode', res.data.staffCode);
            setUserInfo(JSON.stringify(res.data));
            return _context2.abrupt("return", res);
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  //登出功能
  logout: function logout(context) {
    context.commit('removeStaffCode'); // 删除用户codeF
    // 删除token
    context.commit('removeToken'); // 不仅仅删除了vuex中的 还删除了缓存中的
    // 删除用户资料
    context.commit('removeUserInfo'); // 删除用户信息
    //重置路由
    resetRouter();
    //重置路由表
    //vuex里面子模块怎么调用子模块的方法
    context.commit('permission/setRoutes', [], {
      root: true
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};